import React, { Fragment } from 'react';
import { translate } from '../../Services/translation';
import PanelBlasting from './PanelBlasting';
import PanelSubmit from './PanelSubmit';
import ConfiguratorProductDetails from './ConfiguratorProductDetails';
import ProductQuantitySelector from './ProductQuantitySelector';
import { changeProductServiceTab } from '../../Actions/Configurator.action';
import { useDispatch } from 'react-redux';
import closeIcon from '../../../images/closeDialogIcon.svg';

const ProductServiceSwell = () => {
  const dispatch = useDispatch();

  return (
    <Fragment>
        <a className='configurator-close-button' onClick={() => dispatch(changeProductServiceTab(0))}><img src={closeIcon} /></a>
        <div className='configurator-header'>
          <h4>{translate('configurator.production.swell.title')}</h4>
        </div>
        <ConfiguratorProductDetails />
        <ProductQuantitySelector />
        <PanelBlasting />
        <PanelSubmit />
    </Fragment>
  );
};
export default ProductServiceSwell;
